module.exports = __webpack_public_path__ + "assets/7cb79cc483d345a380925605dd4c0a912.jpg";